import React, { useState, useEffect, useCallback } from "react";
import CustomButton from "../../../../atoms/CustomButton";
import Import from "../../../../icons/Import";
import Filter from "../../../../icons/Filter";
import CustomDataGrid from "../../../../organisms/CustomDatagrid";
import Modal from "../../../../organisms/modals/Modal";
import CustomMenu from "../../../../atoms/CustomMenu";
import { v4 as uuidv4 } from "uuid";
import View from "../../../../icons/View";
import Edit from "../../../../icons/Edit";
import Delete from "../../../../icons/Delete";
import Search from "../../../../molecules/search";
import VerticalMenu from "../../../../icons/VerticalMenu";
import { getData , deleteData } from "../../../../../services";
import { useCookies } from "react-cookie";
import Form from "./Form";
import Pagination from '../../../../molecules/Pagination'
import DeleteModal from "../../../../organisms/modals/DeleteModal"
import NoContentCard from "../../../../atoms/NoContentCard";
import NoContentIcon from "../../../../icons/NocontentIcon";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
} from "../../../../../assets/styles/toast";
import { useSelector } from "react-redux";


const Departments = () => {

    const [cookies] = useCookies([]);
    const [selectedRow, setSelectedRow] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [searchedValue, setSearchedValue] = useState();
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [modalState, setModalState] = useState({
      isModalOpen: false,
      modalData: null,
      isDeleteModalOpen: false,
      modalId: "",
      name: "",
    });

    const accessData = useSelector((state) => state.accessDetails?.accessData);
    const isAdmin = accessData?.role?.label === "Admin";


    const DeptManagementAccess = 
    accessData?.access?.find((module) => module.module === "Department") || {};

  
  // Determine if user can edit or delete
   const canEdit = isAdmin || DeptManagementAccess?.is_edit;
   const canDelete = isAdmin || DeptManagementAccess?.is_delete;

   const showMenu = canEdit || canDelete;

    
  
    const getUserData = useCallback(async () => {
      try {
        setIsLoading(true);
        const res = await getData({
          endpoint: "Department/getAllDepartment",
          params: {
            search_query: searchedValue,
            page: currentPage,
            page_limit: itemsPerPage,
            // business_id: cookies.bid,
          },
  
          token: cookies.e_t,
        });
        if (res) {
            const newRes = res;
            const dataWithSNo = newRes?.data.map((item, index) => ({
              ...item,
              sno: (currentPage - 1) * itemsPerPage + index + 1,
            }));
            setTableData({...newRes, data: dataWithSNo});
          }
      } catch (error) {
        console.error(error); // Use console.error for errors
      } finally {
        setIsLoading(false)
      }
    }, [cookies.e_t, currentPage, itemsPerPage,searchedValue]);
  
    useEffect(() => {
      getUserData();
    }, [getUserData]);
  
    //handling menu
    const menu = [
      canEdit && {
        icon: <Edit height="20" width="20" />,
        label: "Edit",
        onClick: () => {
          setAnchorEl(null);
          handleEdit(selectedRow);
        },
      },
      canDelete && {
        icon: <Delete />,
        label: "Delete",
        onClick: () => {
          setAnchorEl(null);
          handleDeleteModal(selectedRow);
        },
      },
    ].filter(Boolean);
  
  
    const handleDeleteModal = (data) => {
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: true,
        modalId: data.id,
        name: data.name,
        email: data.email,
      }));
    };
  
  
    const handleDeletion = async () => {
      try {
        await deleteData({
          endpoint : "Department/deleteDepartment",
          params : {
            id : modalState.modalId,
          },
      });
      toast.success("Department Deleted Sucessfully", {
        style: confimationStyles,
        duration: 1000,
      });
        getUserData();
        setModalState((prevState) => ({
          ...prevState,
          isDeleteModalOpen: false,
        }));
      } catch (error) {
        toast.error("An Error Occured While Deleting", {
          style: errorStyles,
          duration: 1000,
        });
        console.log(error);
      }
    };
  
    const handleStatusMenu = (event, row) => {
      setAnchorEl(event.currentTarget);
      setSelectedRow(row);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
    const handlePageChange = useCallback((page) => {
      setCurrentPage(page);
    }, []);
  
    const handleItemsPerPageChange = useCallback((perPage) => {
      setCurrentPage(1);
      setItemsPerPage(perPage);
    }, []);
  
  
    const handleEdit = (tableData) => {
      setModalState((prevState) => ({
        ...prevState,
        modalId: tableData.id,
        modalData: tableData,
        isModalOpen: true,
        title: "Edit Department",
      }));
    };
  
    const columns = [
      {
        field: "sno",
        headerName: "S.No",
        flex: 0.7,
        sortable: false,
        edittable: false,
      },
      {
        field: "name",
        headerName: "Department",
        flex: 1,
        sortable: true,
      },
      {
        field: "actions",
        headerName: "",
        flex: 0.2,
        renderCell: (params) => {
          if (!showMenu) return null;
          return (
            <div className="table-icons-container">
              <div onClick={(event) => handleStatusMenu(event, params.row)}>
                <VerticalMenu />
              </div>
  
              <CustomMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                items={menu}
              />
            </div>
          );
        },
      },
    ];
  
    
  
    const openModal = (title, data) => {
      const modalId = uuidv4();
      setModalState((prevState) => ({
        ...prevState,
        modalId,
        isModalOpen: true,
        title,
        modalData: data,
      }));
    };
  
    const closeModal = () => {
      // if(type === 'submitted'){
        setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
      // } else {
      //   // setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
      //   setIsFormDirty(true)
      //   setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
      // }
    };

    const CustomNoRowsOverlay = React.memo(() => {
      return (
        <>
          {/* {!!searchedValue ? (
            <NoContentCard
              title="No Record Found"
              type="Company"
              icon={<NoContentIcon />}
              small={true}
            />
          ) : ( */}
          <NoContentCard
            title="No Departments Found"
            type="Employee"
            subtitle={"Try refreshing or add new information to begin."}
          />
          {/* )} */}
        </>
      );
    });


  return (
    <>
 <div className="d-flex justify-content-between">
        <h3 className="h2-j semi-light mb-0">Departments</h3>
        <div className="d-flex gap-2">
        <Search
            placeholder="Search"
            onSearchEmit={(item) => {
              if (currentPage !== 1) {
                setCurrentPage(1);
              }
              setSearchedValue(item);
            }}
          />
          {canEdit && <CustomButton text="Add Department" type="btn-outline-primary"
            handleClick={() => openModal("Add Department")}
          />}
          


        </div>
      </div>
      <div className="mt-3">
        <CustomDataGrid
          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData?.data || []}
          isLoadingStateProvided={true}
          isLoading={isLoading}
          onCellClick={(params) => {
            if (params.field !== "actions" && canEdit) {
              handleEdit(params.row);
            }
          }}
          canEdit={canEdit}
        />
      </div>

      {tableData?.total_record > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_record}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}


      {modalState?.isModalOpen && (
        <Modal
        id={modalState?.modalId}
          title={modalState.title}
          isActive={modalState?.isModalOpen}
          onClose={closeModal}
          takeConfirmation={isFormDirty ? true : false}
          width="650px"
        >
          <Form onFormDirty={setIsFormDirty}
          id = {modalState.modalId} 
          initialValues={
            modalState.title === "Edit Department" ? modalState.modalData : null
          }
          refetchData = {getUserData}
          onClose={() =>closeModal('submit')}/>
        </Modal>
      )}

      {modalState.isDeleteModalOpen && (
          <DeleteModal
            name={modalState.name}
            id={modalState.modalId}
            isActive={modalState.isDeleteModalOpen}
            onClose={() =>
              setModalState((prevState) => ({
                ...prevState,
                isDeleteModalOpen: false,
              }))
            }
            title="Department"
            onClick={handleDeletion}
          />
        )}

    </>
  )
}

export default Departments;